import { AxiosResponse } from 'axios';
import { serverAxios } from 'app/utils/axios';
import { ITrip } from 'app/models/trip';
import { IGetTripsResponse } from 'app/models/responses/trip';

class TripsHttp {
  private static route = '/';
  private static lazyLoadingItem = 10;

  public async getLazy(
    email: string,
    from: string | undefined,
    to: string | undefined,
    limit: number,
  ): Promise<{ count: number; trips: ITrip[] }> {
    return serverAxios
      .post(TripsHttp.route, {
        act: 'find',
        col: 'jobs',
        count: true,
        query: {
          email: email,
          from: { $regex: from ? from : '' },
          to: { $regex: to ? to : '' },
        },
        limit: limit === 0 ? TripsHttp.lazyLoadingItem : limit + TripsHttp.lazyLoadingItem,
      })
      .then((response: AxiosResponse<IGetTripsResponse>) => {
        return { count: response.data.count, trips: response.data.data };
      });
  }

  public async cancelTrip(id: string, draftPass: string): Promise<void> {
    return serverAxios
      .post(TripsHttp.route, {
        act: 'jobdraftcancel',
        id,
        draftPass,
      })
      .then(() => {
        return;
      });
  }
}

export default TripsHttp;
